<template>
  <div class="_citys" @click.stop.prevent="">
    <div style="position: relative">
      <span title="关闭" @click="closeCity()">X</span>
      <ul id="_citysheng" class="_citys0">
        <li :class="{ citySel: currentIndex == 0 }" @click="openLI(0)">省份</li>
        <li :class="{ citySel: currentIndex == 1 }" @click="openLI(1)">城市</li>
      </ul>
      <div
        id="_citys0"
        v-show="currentIndex == 0"
        class="_comcity _citys1"
        style="display: inline-block"
      >
        <template v-if="listInfo" v-for="(item, index) in listInfo">
          <a
            href="javascript:void(0);"
            :key="item.province"
            :class="{ 'm-active': selectPro == item.province }"
            @click="setCity(item, index, 1)"
            >{{ item.province }}</a
          >
        </template>
      </div>
      <div v-show="currentIndex == 1" id="_citys1" class="_comcity _citys1">
        <template v-if="listCity" v-for="(item, index) in listCity">
          <a
            href="javascript:void(0);"
            :key="item.id"
            @click="setArea(item)"
            class="cityItem"
            :class="{ 'm-active': selectCityId == item.id }"
            >{{ item.name }}</a
          >
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../config/api.js";
export default {
  name: "select-city",
  props: ["curPro", "curId", "curCity"],
  data: function () {
    return {
      currentIndex: 0,
      listInfo: [],
      listCity: [],
      selectPro: this.curPro,
      selectCity: this.curCity,
      selectCityId: this.curId,
    };
  },
  created: function () {
    //调用查询方法 并且默认第一个省份跟城市
    let vm = this;
    // let url = api.TOP_URL +"app-api/province/v4/query/list";
    let url = api.API_URL + "/province/v1/query/area/list";
    vm.getAjax(
      url,
      "",
      function (result) {
        if (result.rcode == "000000" && result.rdata) {
          vm.listInfo = vm.exchangeData(result.rdata); //所有城市信息
          if (vm.selectCityId && vm.selectCityId != "") {
            for (let i = 0; i < vm.listInfo.length; i++) {
              if (vm.listInfo[i].province == vm.selectPro) {
                //
                vm.listCity = vm.listInfo[i].citys;
                break;
              }
            }
          } else {
            vm.listCity = vm.listInfo[0].citys;
          }
        }
      },
      function () {}
    );
  },
  methods: {
    exchangeData(list) {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        let citys = [];
        for (let n = 0; n < list[i].childList.length; n++) {
          citys.push({
            id: list[i].childList[n].id,
            name: list[i].childList[n].name,
            provinceName: list[i].name,
          });
        }
        arr.push({
          id: list[i].id,
          province: list[i].name,
          citys: citys,
        });
      }
      console.log("arr", arr);
      return arr;
    },
    closeCity: function () {
      //关闭弹出框 触发事件
      this.$emit("getCity", {
        selectPro: this.selectPro,
        selectCity: this.selectCity,
        selectCityId: this.selectCityId,
      });
    },
    openLI: function (index) {
      //弹出对应的省份
      this.currentIndex = index;
    },
    setCity: function (item, index, j) {
      //选择城市
      this.listCity = item.citys;
      this.openLI(j);
      this.selectPro = item.name; //选择的省份
    },
    setArea: function (item) {
      //选中区域后 关闭弹出框
      this.selectPro = item.provinceName;
      this.selectCityId = item.id;
      this.selectCity = item.name;
      this.closeCity();
    },
  },
};
</script>
<style scoped="">
.cityItem {
  overflow: hidden; /*自动隐藏文字*/
  text-overflow: ellipsis; /*文字隐藏后添加省略号*/
  white-space: nowrap; /*强制不换行*/
}
._citys {
  width: 385px;
  display: inline-block;
  border-radius: 3px;
  padding: 12px 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  position: absolute;
  left: 0px;
  z-index: 10000;
  top: 5px;
  background-color: #fff;
  text-align: left;
}
._citys span {
  color: #888;
  height: 15px;
  width: 15px;
  line-height: 15px;
  text-align: center;
  border-radius: 3px;
  position: absolute;
  right: 0px;
  top: 12px;
  cursor: pointer;
}
._citys0 {
  width: 100%;
  height: 34px;
  display: inline-block;
  border-bottom: 2px solid #f5f5f5;
  padding: 0;
  margin: 0;
}
._citys0 li {
  display: inline-block;
  line-height: 34px;
  font-size: 15px;
  color: #888;
  width: 80px;
  text-align: center;
  cursor: pointer;
}
.citySel {
  border-bottom: 2px solid #a28b77 !important;
  color: #a28b77 !important;
  margin-top: -2px;
  z-index: 10000;
}
._citys1 {
  width: 100%;
  display: inline-block;
  padding: 10px 0;
}
._citys1 a {
  width: 110px;
  height: 36px;
  display: inline-block;
  color: #666;
  line-height: 35px;
  text-align: center;
  cursor: pointer;
  font-size: 13px;
  overflow: hidden;
  margin-top: 4px;
}
._citys1 a:hover,
._citys1 a.m-active {
  color: #a28b77;
}
.AreaS {
  background-color: #a28b77 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// select-city.vue?70337f7b